import type {
    DietAndPsychAdvice,
    MdoInterimReportAdvice,
    MdoReportAdvice,
    MedConsultAssessmentAdvice,
    PatientPresence,
} from '@common/customControls/bariatrics';
import type { IProcessActivityReadSection } from '@common/interfaces/processActivityReadSection';
import type { ValueAndColorOption } from '@frontend/components/fields/FormGroupBadge';
import type { ComponentsMap } from '@frontend/formEngine/readForm/readForm.types';
import { getProcessActivityReadSectionItem } from '@common/utils/processActivityReadUtil';
import { FormGroupBadge } from '@frontend/components/fields/FormGroupBadge';
import { dietAndPsychAdviceWithColor } from '../customControls/bariPre/utils';
import { PatientPresenceFormGroup } from '../customControls/PatientPresenceFormGroup';

export function addAanwezigheidComponent<ReadData extends { aanwezigheid: PatientPresence | null }>(
    readSections: IProcessActivityReadSection[],
    map: ComponentsMap
): void {
    const aanwezigheidItem = getProcessActivityReadSectionItem<ReadData>()(readSections, 'aanwezigheid');
    if (aanwezigheidItem) {
        map.set(aanwezigheidItem.key, <PatientPresenceFormGroup presence={aanwezigheidItem.value} />);
    }
}

export function addAdviesComponent<ReadData extends { advies: DietAndPsychAdvice | null }>(
    readSections: IProcessActivityReadSection[],
    map: ComponentsMap
): void {
    const adviesItem = getProcessActivityReadSectionItem<ReadData>()(readSections, 'advies');
    if (adviesItem) {
        map.set(
            adviesItem.key,
            <FormGroupBadge
                label={adviesItem.label}
                options={dietAndPsychAdviceWithColor}
                value={adviesItem.value}
            />
        );
    }
}

export function addHervattenComponent<
    ReadData extends { hervatten: Exclude<MdoReportAdvice | MdoInterimReportAdvice, MdoReportAdvice.notYet> | null },
>(readSections: IProcessActivityReadSection[], adviceWithColor: ValueAndColorOption[], map: ComponentsMap): void {
    const hervattenItem = getProcessActivityReadSectionItem<ReadData>()(readSections, 'hervatten');
    if (hervattenItem) {
        map.set(
            hervattenItem.key,
            <FormGroupBadge
                label={hervattenItem.label}
                options={adviceWithColor}
                value={hervattenItem.value}
            />
        );
    }
}

export function addInclusieInZorgpadComponent<
    ReadData extends {
        inclusie_in_zorgpad: MdoInterimReportAdvice | MdoReportAdvice | MedConsultAssessmentAdvice | null;
    },
>(readSections: IProcessActivityReadSection[], adviceWithColor: ValueAndColorOption[], map: ComponentsMap): void {
    const inclusieInZorgpadItem = getProcessActivityReadSectionItem<ReadData>()(readSections, 'inclusie_in_zorgpad');
    if (inclusieInZorgpadItem) {
        map.set(
            inclusieInZorgpadItem.key,
            <FormGroupBadge
                label={inclusieInZorgpadItem.label}
                options={adviceWithColor}
                value={inclusieInZorgpadItem.value}
            />
        );
    }
}
